(function ($) {

  // make sure this is only run when the document has fully been loaded and we can find the mainnav node
  $(function() {
    const _gaq = window._gaq || [];
    // logging the search terms used in the custom search console; see SAB-350
    var attachedEventHandler = false,
      logSearchTerm = function () {
        var searchTerm = $('#gsc-i-id1').val();

        _gaq.push(['_trackEvent', 'search', 'gcs_search', searchTerm]);
      },
      logSearchTermOnEnterEvent = function (ev) {
        if (ev.keyCode == 13) {
          logSearchTerm();
        }
      };

    // react to the submit button of the search form being pressed
    $('#mainnav').on('click', 'input.gsc-search-button', logSearchTerm);

    // The element "gsc-i-id1" is not always present when this code is first run; so we wait until a user actually
    // enters a search term before attaching the handler.
    // We cannot attach it to a parent element as the keydown will not propagate to the parent when enter is pressed.
    // Also, it must be the keydown event, as keypress apparently is not called at all.
    $('#mainnav').on('keydown', function() {
      if (!attachedEventHandler) {
        attachedEventHandler = true;

        $('#gsc-i-id1').on('keydown', logSearchTermOnEnterEvent);
      }
    });
  });
})(jQuery);
